//=== Consultation Form, section imagerie
// Les 3 voies (depot Purview, courrier, lien de portail) sont cumulables : aucune ne
// decoche les autres. Les regles de validation vivent dans parsley-setup.js, ce fichier
// ne gere que le comportement de l'interface.
(function($) {

  //=== Depot Purview
  // Ouvrir la lightbox vaut declaration de depot : on coche, sans jamais decocher (le
  // patient peut l'ouvrir pour relire la marche a suivre apres avoir deja depose).
  $(document).on('click', '[href="#purview_uploader"]', function() {
    $('input[name="imagery-cd"]').prop('checked', true).trigger('change');
  });

  //=== Deuxieme examen d'un bloc
  // Les champs sont deja rendus, seulement masques : rien a cloner, les name sont poses
  // cote PHP. Deux entrees au maximum par bloc, le bouton disparait une fois utilise.
  $(document).on('click', '[data-add-exam]', function() {
    const $button = $(this);
    const $block = $button.closest('.imaging-block');

    $block.find('.imaging-entry[data-imaging-entry="2"]').removeClass('hidden');

    // L'intitule prend la place exacte du bouton, pour que la seconde entree se
    // distingue de la premiere sans separateur
    $button.addClass('hidden');
    $block.find('.imaging-entry-label').removeClass('hidden');
  });

  //=== Bloc a fournir en priorite selon la pathologie
  // La correspondance vient de Consultation::PATHOLOGY_IMAGING, serialisee par le Blade.
  // Purement indicatif : la regle bloquante, elle, vit dans parsley-setup.js et dans
  // Consultation::validate_imaging().
  const PATHOLOGY_IMAGING = $('.imaging-blocks').data('pathology-imaging') || {};

  function refreshRequiredBlock() {
    const expected = PATHOLOGY_IMAGING[$('input[name="main-problem"]:checked').val()];

    $('.imaging-block').each(function() {
      const $block = $(this);
      const marked = Boolean(expected) && $block.data('imaging-type') === expected;

      $block.toggleClass('imaging-block--required', marked);
      $block.find('.imaging-required-note').toggleClass('hidden', !marked);
    });
  }

  refreshRequiredBlock();
  $(document).on('change', 'input[name="main-problem"]', refreshRequiredBlock);

  //=== Tout ou rien sur une entree
  // Une entree est une unite de 5 champs : des qu'un est renseigne, les 4 autres le
  // deviennent. Doublure exacte de Consultation::validate_imaging() cote serveur.
  function refreshEntry($entry) {
    const $inputs = $entry.find('input');
    const filled = $inputs.filter(function() {
      return $.trim(this.value) !== '';
    }).length > 0;

    $inputs.each(function() {
      const $input = $(this);

      if (filled) {
        $input.attr('data-parsley-required', 'true').attr('required', 'required');
        return;
      }

      $input.removeAttr('data-parsley-required').removeAttr('required');

      if ($input.parsley()) {
        $input.parsley().reset();
      }
    });
  }

  // Delegation obligatoire : les champs de la 2e entree sont masques au chargement, et
  // Flatpickr enveloppe les champs date. L'evenement change couvre le choix au calendrier,
  // input couvre la saisie clavier.
  $(document).on('input change', '.imaging-entry input', function() {
    refreshEntry($(this).closest('.imaging-entry'));
  });

  // Etat initial, et retour arriere du navigateur qui restaure les valeurs saisies
  $('.imaging-entry').each(function() {
    refreshEntry($(this));
  });

  //=== Revalidation de la section
  // Le porteur n'est revalide qu'apres une premiere tentative de soumission : sinon
  // l'erreur « au moins une voie » s'afficherait des la premiere frappe dans le formulaire.
  let submitAttempted = false;

  $.listen('parsley:form:validate', function() {
    submitAttempted = true;
  });

  $(document).on('change input', 'input[name="imagery-cd"], input[name="imagery-posted"], .imaging-entry input, input[name="main-problem"]', function() {
    if (!submitAttempted) {
      return;
    }

    const $carrier = $('.imagery-route-check input');

    if ($carrier.length && $carrier.parsley()) {
      $carrier.parsley().validate();
    }
  });

})(jQuery);
